import { render, staticRenderFns } from "./QuestionsAndComplaintsSection.vue?vue&type=template&id=d1805a92&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports